import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Stream from '../screens/stream';

const AppRoutes = () => {
    return (
        <Router>
            <Routes>
                <Route path="/:cam_name" element={<Stream />} />
                <Route path="*" element={<h1>No Page FOUND</h1>} />
            </Routes>
        </Router>
    );
};

export default AppRoutes;